import {gref} from "@/helpers/gref";

export function saveToLocalStore() {
    localStorage.setItem(
      "clusterflyDash",
      JSON.stringify(Object.fromEntries(gref.value.get("components")))
    );
  }